module.exports = __webpack_public_path__ + "img/9788963701103.4d74508f.jpg";